<template>
    <div class="xiangmu">
<!--        <breadcrumb :routerList="[{to:'/dingd/myOrderList',title:'订单管理'},{title:'内销发货确认'}]" style="width:100%"-->
<!--                    v-if="roleType == '1' "/>-->
<!--        <breadcrumb :routerList="[{to:'/dingd/myOrderList',title:'订单管理'},{title:'外销发货确认'}]" style="width:100%"-->
<!--                    v-if="roleType == '2' "/>-->
<!--        <breadcrumb :routerList="[{to:'/dingd/myOrderList',title:'订单管理'},{title:'免费订单发货确认'}]" style="width:100%"-->
<!--                    v-if="roleType == '4' "/>-->
<!--        <breadcrumb :routerList="[{to:'/dingd/myOrderList',title:'订单管理'},{title:'发货确认'}]" style="width:100%"-->
<!--                    v-if="roleType == '3' "/>-->
      <Breadtabsheader/>
        <div class="h-piece h-mrt30">
            <div class="h-formBox">
                <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder">
					<div class="h-thirdColumn w-newColumn">
						<el-form-item label="订单编号" prop="sapCodeLike" style="width: 50%;">
							<el-input
									v-model="formInline.sapCodeLike"
									placeholder="多订单模糊查询请用空格或分号分隔"
									clearable></el-input>
						</el-form-item>
						<el-form-item label="产品编码" prop="materialCodeLike">
						    <el-input
						            v-model="formInline.materialCodeLike"
						            placeholder="请输入"
						            clearable></el-input>
						</el-form-item>
						<el-form-item label="创建人" prop="cuname">
							<el-input
									v-model="formInline.cuname"
									placeholder="请输入"
									clearable></el-input>
						</el-form-item>
					</div>
					<el-collapse-transition>
						<div v-show="isScreen">
							<div class="h-thirdColumn w-newColumn">
								<el-form-item label="　　订单创建时间" prop="cdate" style="width: 50%;">
									<el-date-picker
											placeholder="请选择"
											v-model="formInline.cdatebegin"
											clearable
											type="date"
											value-format="yyyy-MM-dd" >
									</el-date-picker>
									<span class="w-time-to">至</span>
									<el-date-picker
											placeholder="请选择"
											v-model="formInline.cdateend"
											clearable
											type="date"
											value-format="yyyy-MM-dd" >
									</el-date-picker>
								</el-form-item>
								<el-form-item label="　售达方国家/区域" prop="soldToAreaName">
									<el-input
											v-model="formInline.soldToAreaName"
											placeholder="请输入"
											clearable></el-input>
								</el-form-item>
								<el-form-item label="售达方名称" prop="soldToName">
									<el-input
											v-model="formInline.soldToName"
											placeholder="请输入"
											clearable></el-input>
								</el-form-item>
							</div>
							<div class="h-thirdColumn w-newColumn">
								<el-form-item label="最后审核日期" prop="taskEnddate" style="width: 50%;">
									<el-date-picker
											placeholder="请选择"
											v-model="formInline.taskEnddateBg"
											clearable
											type="date"
											value-format="yyyy-MM-dd" >
									</el-date-picker>
									<span class="w-time-to">至</span>
									<el-date-picker
											placeholder="请选择"
											v-model="formInline.taskEnddateEd"
											clearable
											type="date"
											value-format="yyyy-MM-dd" >
									</el-date-picker>
								</el-form-item>
								<el-form-item label="销售组织" prop="saleGroupCode">
									<brselect category="xiaoshou_zuzhi" :v="formInline.saleGroupCode" :showcode="true"
											  v-model="formInline.saleGroupCode" clearable></brselect>

								</el-form-item>
								<el-form-item label="产地" prop="factory">
									<brselect category="factory" :v="formInline.factory" :showcode="true"
											  v-model="formInline.factory" clearable></brselect>

								</el-form-item>
							</div>
						</div>
					</el-collapse-transition>
                </el-form>
				<div class="l-screenBox">
					<div class="l-screen" @click="collapseChange">
						<img :src="isScreen?closeScreen:drawScreen" alt="">
						<div class="l-screenText">{{isScreen?"收起":"展开"}}</div>
					</div>
					<div class="l-retrieval">
						<el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
						<el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
					</div>
				</div>
            </div>
        </div>


        <div class="h-table h-mrt30" v-if="roleType=='1' ||  roleType=='4'">
            <el-table
                    @selection-change="handleSelectionChange"
                    :data="tableData"
                    stripe
					border
                    style="width: 100%"
					max-height="510"
            >
                <el-table-column
						fixed
                        type="selection"
                        width="40"
                        :label="all"
                >
                </el-table-column>
				<el-table-column
					   type="index"
					   label="#"
					   fixed
					   width="40">
				</el-table-column>
                <el-table-column
						fixed
                        prop="sapCode"
                        :show-overflow-tooltip="true"
                        label="订单编号"
                        width="120">
                </el-table-column>
                <el-table-column
                        prop="soldToName"
                        label="经销商"
                        :show-overflow-tooltip="true"
                        width="180">
						<template scope="scope">
							<div style="text-align: left;">
								{{scope.row.soldToName}}
							</div>
						</template>
                </el-table-column>
                <el-table-column
                        prop="tejiashuoming"
                        label="特价说明"
                        :show-overflow-tooltip="true"
                        width="150">
                </el-table-column>
                <el-table-column
                        prop="note"
                        label="订单备注"
                        :show-overflow-tooltip="true"
                        width="110">
							<template slot-scope="scope">
								<div style="text-align: left;">
									{{scope.row.note}}
								</div>
							</template>
                </el-table-column>
                <el-table-column
                        prop="proModelName"
                        label="产品大类"
                        width="100">
                </el-table-column>
                <el-table-column
                        prop="materialCode"
                        label="产品编码"
                        :show-overflow-tooltip="true"
                        width="110">
                </el-table-column>
                <el-table-column
                        prop="materialName"
                        label="产品型号"
                        :show-overflow-tooltip="true"
                        width="120">
                </el-table-column>
                <el-table-column
                        prop="proType"
                        label="型号属性"
                        :show-overflow-tooltip="true"
                        width="90">
                </el-table-column>
                <el-table-column
                        prop="isStockUp"
                        label="是否备货"
                        :show-overflow-tooltip="true"
                        width="90">
                    <template scope="scope">
                        {{scope.row.isStockUp|dictname('shifou_keyong')}}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="proNumber"
                        label="产品数量"
                        :show-overflow-tooltip="true"
                        width="90">
							<template slot-scope="scope">
								<div style="text-align: right;">
									{{scope.row.proNumber}}
								</div>
							</template>
                </el-table-column>
                <el-table-column
                        prop="availableNum"
                        label="可用库存"
                        :show-overflow-tooltip="true"
                        width="90">
							<template slot-scope="scope">
								<div style="text-align: right;">
									{{scope.row.availableNum}}
								</div>
							</template>
                </el-table-column>
                <el-table-column
                        prop="syNum"
                        label="剩余库存"
                        :show-overflow-tooltip="true"
                        width="90">
							<template slot-scope="scope">
								<div style="text-align: right;">
									{{scope.row.syNum}}
								</div>
							</template>
                </el-table-column>
                <el-table-column
                        prop="payMethod"
                        label="付款方式"
                        width="270"
                        :show-overflow-tooltip="true"
                >
                    <template scope="scope">
                        {{`现金占用：${ scope.row.jinexj } ${ scope.row.currencyCode }`}}
                        {{`信贷占用：${ scope.row.jinexd } ${ scope.row.currencyCode }`}}
                    </template>
                </el-table-column>

                <el-table-column
                        prop="cdate"
                        label="审核时间"
                        :show-overflow-tooltip="true"
                        width="160">
                </el-table-column>

                <el-table-column
                        prop="soldToAreaName"
                        label="售达方国家"
                        :show-overflow-tooltip="true"
                        width="150">
                </el-table-column>
				<el-table-column label="销售组织" :show-overflow-tooltip="true" width="150">
					<template scope="scope">
						{{scope.row.saleGroupCode|dictname('xiaoshou_zuzhi') }}
					</template>
				</el-table-column>
				<el-table-column
						prop="factory"
						label="产地"
						width="120"
						:show-overflow-tooltip="true">
					<template scope="scope">
						{{scope.row.factory|dictname('factory') }}
					</template>
				</el-table-column>
				<el-table-column
						prop="taskEnddate"
						label="最后审核日期"
						:show-overflow-tooltip="true"
						:formatter="formatDateGMT"
						width="160">
				</el-table-column>
                <el-table-column
                        prop="cdate"
                        label="创建时间"
                        :show-overflow-tooltip="true"
                        width="160">
                </el-table-column>
                <el-table-column
                        prop="cuname"
                        label="创建人"
                        :show-overflow-tooltip="true"
                        width="80">
                </el-table-column>

                <el-table-column
                        label="操作"
                        width="100"
                        fixed="right"
                >
                    <template slot-scope="scope">
						<div style="display: flex;align-items: center;justify-content: flex-start;">
							<el-button
							        type="text"
							        size="small"
									style="padding: 0;"
							        class="h-tableLink h-btn"
							        @click="goDetails(scope.row)">
							    查看
							</el-button>
							<el-button
									style="margin-left: 0.1rem;padding: 0;"
							        @click="send(scope.row.sapCode)"
							        type="text"
							        size="small"
							        class="h-tableLink h-btn"
							>
							    发货
							</el-button>
						</div>
						<!-- <div class="l-operationBox">
							<span class="l-operationlist br-operation-look" title="查看" @click="goDetails(scope.row)"></span>
							<span class="l-operationlist br-operation-fh" title="安排发货" @click="send(scope.row.sapCode)"></span>
						</div> -->
                    </template>
                </el-table-column>
            </el-table>
            <div class="h-tableB h-mrt30">
                <div class="h-tableBL">
                    <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                               style="margin-left:-20px;" @click="downloadExcel">批量导出
                    </el-button>
					<el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-fahuo" @click="sendAll">
						批量安排发货
					</el-button>
                </div>
                <div class="h-pagination2 h-pageCenter">
                    <pagination :page="formInline" @query="query"/>
                </div>
            </div>
        </div>


        <div class="h-table h-mrt30" v-if="roleType=='2' ||  roleType=='3' ">
            <el-table
                    @selection-change="handleSelectionChange"
                    :data="tableData"
                    :span-method="objectSpanMethod"
                    stripe
					border
                    style="width: 100%"
					max-height="510"
            >
                <el-table-column
                        type="selection"
                        width="40"
                        :label="all"
						fixed
                >
                </el-table-column>
                <el-table-column
                	   type="index"
                	   label="#"
                	   fixed
                	   width="40">
                </el-table-column>
                <el-table-column
                        prop="sapCode"
						fixed
                        :show-overflow-tooltip="true"
                        label="订单编号"
                        width="120">
                </el-table-column>
                <el-table-column
                        prop="soldToName"
                        label="经销商"
                        :show-overflow-tooltip="true"
                        width="150">
						<template scope="scope">
							<div style="text-align: left;">
								{{scope.row.soldToName}}
							</div>
						</template>
                </el-table-column>
                <el-table-column
                        prop="dnStatus"
                        label="信用查询是否通过"
                        :show-overflow-tooltip="true"
                        width="150">
                    <template scope="scope">
                        {{scope.row.dnStatus|dictname('pgiStatus')}}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="note"
                        label="订单备注"
                        :show-overflow-tooltip="true"
                        width="150">
						<template scope="scope">
							<div style="text-align: left;">
								{{scope.row.note}}
							</div>
						</template>
                </el-table-column>
                <el-table-column
                        prop="proModelName"
                        label="产品大类"
                        width="100">
                </el-table-column>
                <el-table-column
                        prop="materialCode"
                        label="产品编码"
                        :show-overflow-tooltip="true"
                        width="110">
                </el-table-column>
                <el-table-column
                        prop="materialName"
                        label="产品型号"
                        :show-overflow-tooltip="true"
                        width="120">
                </el-table-column>
                <el-table-column
                        prop="proType"
                        label="型号属性"
                        :show-overflow-tooltip="true"
                        width="90">
                </el-table-column>
                <el-table-column
                        prop="isCustommed"
                        label="常规或改制"
                        :show-overflow-tooltip="true"
                        width="110">
                    <template slot-scope="scope">
                        <div v-if="scope.row.isCustommed == 0">
                            常规
                        </div>
                        <div v-else>
                            改制
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="extraDes"
                        label="改制描述"
                        :show-overflow-tooltip="true"
                        width="150">
                </el-table-column>
                <el-table-column
                        prop="isStockUp"
                        label="是否备货"
                        :show-overflow-tooltip="true"
                        width="90">
                    <template scope="scope">
                        {{scope.row.isStockUp|dictname('shifou_keyong')}}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="proNumber"
                        label="产品数量"
                        :show-overflow-tooltip="true"
                        width="90">
							<template slot-scope="scope">
								<div style="text-align: right;">
									{{scope.row.proNumber}}
								</div>
							</template>
                </el-table-column>
                <el-table-column
                        prop="availableNum"
                        label="可用库存"
                        :show-overflow-tooltip="true"
                        width="90">
							<template slot-scope="scope">
								<div style="text-align: right;">
									{{scope.row.availableNum}}
								</div>
							</template>
                </el-table-column>
                <el-table-column
                        prop="syNum"
                        label="剩余库存"
                        :show-overflow-tooltip="true"
                        width="90">
							<template slot-scope="scope">
								<div style="text-align: right;">
									{{scope.row.syNum}}
								</div>
							</template>
                </el-table-column>
                <el-table-column
                        prop="payMethod"
                        label="付款方式"
                        width="270"
                        :show-overflow-tooltip="true"
                >
                    <template scope="scope">
                        {{`现金占用：${ scope.row.jinexj } ${ scope.row.currencyCode }`}}
                        {{`信贷占用：${ scope.row.jinexd } ${ scope.row.currencyCode }`}}
                    </template>
                </el-table-column>

                <el-table-column
                        prop="sptgTime"
                        label="审核时间"
                        :show-overflow-tooltip="true"
                        width="160">
                </el-table-column>

                <el-table-column
                        prop="soldToAreaName"
                        label="售达方区域/国家"
                        :show-overflow-tooltip="true"
                        width="150">
                </el-table-column>
				<el-table-column label="销售组织"  prop="saleGroupCode" :show-overflow-tooltip="true" width="150">
					<template scope="scope">
						{{scope.row.saleGroupCode|dictname('xiaoshou_zuzhi') }}
					</template>
				</el-table-column>
				<el-table-column
						prop="factory"
						label="产地"
						width="120"
						:show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column
						prop="taskEnddate"
						label="最后审核日期"
						:show-overflow-tooltip="true"
						:formatter="formatDateGMT"
 						width="160">
				</el-table-column>
                <el-table-column
                        prop="cdate"
                        label="创建时间"
                        :show-overflow-tooltip="true"
                        width="160">
                </el-table-column>
                <el-table-column
                        prop="cuname"
                        label="创建人"
                        :show-overflow-tooltip="true"
                        width="80">
                </el-table-column>

                <el-table-column
                        label="操作"
                        width="100"
                        fixed="right"
                >
                    <template slot-scope="scope">
                        <div style="display: flex;align-items: center;justify-content: flex-start;">
							<el-button
							        type="text"
							        size="small"
									style="padding: 0;"
							        class="h-tableLink h-btn"
							        @click="goDetails(scope.row)">
							    查看
							</el-button>

							<el-button
									style="margin-left: 0.1rem;padding: 0;"
							        @click="send(scope.row.sapCode)"
							        type="text"
							        size="small"
							        class="h-tableLink h-btn"
							>
							    发货
							</el-button>
						</div>
						<!-- <div class="l-operationBox">
							<span class="l-operationlist br-operation-look" title="查看" @click="goDetails(scope.row)"></span>
							<span class="l-operationlist br-operation-fh" title="安排发货" @click="send(scope.row.sapCode)"></span>
						</div> -->
                    </template>
                </el-table-column>
            </el-table>
            <div class="h-tableB h-mrt30">
                <div class="h-tableBL">
                    <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                               style="margin-left:-20px;" @click="downloadExcel">批量导出
                    </el-button>
                    <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-fahuo" @click="sendAll">
						批量安排发货
                    </el-button>
                </div>
                <div class="h-pagination2 h-pageCenter">
                    <pagination :page="formInline" @query="query"/>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

    import ss from '../../api/SystemService'
    import updownfile from '../../utils/updownfile';

    export default {
        data() {
            return {
				// 展开折叠筛选
				isScreen:false,
				closeScreen:require("@/assets/images/pimg/closeallic.png"),
				drawScreen:require("@/assets/images/pimg/dobleArr.png"),
                // 新手引导页
                showOrhide: false,
                status: 1,
                checked: true,
                toshow: "orderNxSend1",
                //内外销区分
                roleType: '2',
                //当前登陆人的权限列表
                rolelist: [],
                instid: null,
                showhistory: null,
                imgflag3: false,
                orderTypeList: [],
                //用户项目
                allProjectByUser: [],
                //是否有项目
                xiangmuTab: false,
                //销售组织，下拉
                xszz: [],
                fxqd: [],
                spanArr: [],
                //表单
                formInline: {
                    orderCategory: '',
                    sapCodeLike: '',
                    materialCodeLike: '',
                    payMethodLike: '',
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                    oid: '',
                    materialCode: '',
                    payMethod: '',
                    ids: '',
                    orderStatus: '',
                    cuname: '',
                    cdatebegin: '',
                    cdateend: '',
                    soldToAreaName: '',
					taskEnddateBg:'',
					taskEnddateEd:'',
                },
                all: '全部',
                //表格
                multipleSelection: [],
                tableData: [],
                sapCodes: [],
                clickActive: 1,
				fahuoFlag:true
            }
        },
        methods: {
			// 展开折叠
			collapseChange(){
				this.isScreen = !this.isScreen;
			},
            //查看详情跳转
            goDetails(row) {
                var instid = null;
                if (row.orderCategory == '1') {
                    instid = row.binstid;
                } else {
                    instid = row.instid;
                }
                if (row.orderCategory == '1') {
                    this.$router.push({
                        path: "/dingdmain/orderNxshenpi",
                        query: {id: row.bid, instid: instid, taskstatus: '1', f: '1'}
                    })
                }else if (row.orderCategory == '3') {
                    this.$router.push({
                        path: "/dingdmain/orderShshenpi",
                        query: {id: row.bid, instid: instid, taskstatus: '1', f: '1'}
                    })
                } else {
                    this.$router.push({
                        path: "/dingdmain/orderWxshenpi",
                        query: {id: row.bid, instid: instid, taskstatus: '1', f: '1'}
                    })
                }
            },
            // 重置按钮
            resetData() {
                this.formInline.sapCodeLike = "";
                this.formInline.materialCodeLike = "";
                this.formInline.payMethodLike = "";
                this.formInline.cuname = "";
                this.formInline.cdatebegin = "";
                this.formInline.cdateend = "";
                this.formInline.soldToAreaName = "";
				this.formInline.taskEnddateBg = "";
				this.formInline.taskEnddateEd = "";
                this.query();
            },

            //查询该用户及所有子用户所有订单详情

            query() {

                if (this.roleType != '4' && this.roleType != '3') {
                    this.formInline.orderCategory = this.roleType;
                }
                if(this.roleType == '3'){
                    this.formInline.orderCategory = null;
                }
                this.formInline.orderCategory1 = this.roleType == '4' ? '6' : null;
                ss.OrderMainService.selectStockPage(this.formInline).then(rd => {
                    this.tableData = rd.records;
                    this.tableData.forEach((item, index) => {
                        item.moneybackStatus = item.moneybackStatus == '2' ? '0' : item.moneybackStatus;
                        item.availableNum = item.availableNum || 0;
                        item.syNum = item.availableNum;
                        if(item.zhiliangyijian){
                            item.note = (item.note ? '订单备注:' + item.note + ';' : '') + '   质量部门意见:' + item.zhiliangyijian
                        }
                    })
                    console.log('我在这儿呀', this.tableData);
                    this.formInline.total = rd.total || 0;
                    this.getSpanArr();
                });
            },
            getSpanArr() {
                this.spanArr = [];
                this.tableData.forEach((item, index) => {
                    if (index === 0) {
                        this.spanArr.push(1);
                        this.position = 0;
                    } else {
                        if (this.tableData[index].sapCode === this.tableData[index - 1].sapCode) {
                            this.spanArr[this.position] += 1;
                            this.spanArr.push(0);
                        } else {
                            this.spanArr.push(1);
                            this.position = index;
                        }
                    }
                })
            },
            objectSpanMethod({row, column, rowIndex, columnIndex}) {

                if (column.label == '经销商' && row.orderCategory == '2') {
                    const _row = this.spanArr[rowIndex];
                    const _col = _row > 0 ? 1 : 0;
                    return {
                        rowspan: _row,
                        colspan: _col
                    }
                }

                if (column.label == '订单编号' && row.orderCategory == '2') {
                    const _row = this.spanArr[rowIndex];
                    const _col = _row > 0 ? 1 : 0;
                    return {
                        rowspan: _row,
                        colspan: _col
                    }
                }

                if ((column.label == '付款方式' || column.label == '操作') &&
                    (row.status == '10' || row.orderCategory == '2')) {
                    const _row = this.spanArr[rowIndex];
                    const _col = _row > 0 ? 1 : 0;
                    return {
                        rowspan: _row,
                        colspan: _col
                    }
                }

            },
            //导出Excel
			downloadExcel() {
				this.$msg.confirm("确认导出?", () => {
					var idlist = [];
					this.multipleSelection.forEach(element => {
						idlist.push(element.sapCode);
					});
					var q = this.formInline;
					if (idlist) {
						q.id = idlist.join(",");
					} else {
						q.id ='';
					}
					console.log("q", q);
					updownfile.down("/api/swyl/v1/dingdmain/getOrderExcelA", q, "post", 'params');
				})
			},

            //勾选事件
            handleSelectionChange(val) {
                this.multipleSelection = val;
                this.multipleSelection.forEach(element => {
                    element.syNum = element.availableNum - element.proNumber;
                });
            },
            handleFilter() {
                this.formInline.pageNo = 1;
                this.query();
            },
            //安排发货方法
            send(x) {
                this.$msg.confirm("确认发货?", () => {
                    ss.OrderMainService.confirmSendNew(x).then(rd => {
                        this.$msg.msgs(rd.msg);
                        this.query();
                    });
                })
            },

            //批量安排发货
            sendAll() {
			    if(this.fahuoFlag){
                    this.$msg.confirm("确认批量发货?", () => {
                        this.fahuoFlag = false;
                        var sapIds = [];
                        this.multipleSelection.forEach(element => {
                            sapIds.push(element.sapCode);
                        });
                        this.sapCodes = sapIds;
                        ss.OrderMainService.confirmSendAll(this.sapCodes).then(rd => {
                            this.$msg.msgs(rd.msg);
                            this.query();
                            this.fahuoFlag = true;
                        });
                    })
				}else{
					this.$msg.error("不能执行重复发货，请刷新页面重新加载！");
				}
            },


            getRole() {
                this.rolelist = this._user.roles;
                console.log('我在这儿呀', this.rolelist);
                this.rolelist.forEach(elements => {
                    if (elements.id == "swyl_dingdgly" || elements.id == "swyl_dingdgly_ks" || elements.id == "swyl_dingdgly_hsj" || elements.id == "swyl_hsj_all") {
                        this.roleType = '1';
                    }
                    if (elements.id == "swyl_waixiaogly") {
                        this.roleType = '2';
                    }
                    if (elements.id == "swyl_admin") {
                        this.roleType = '3';
                    }
                    if (elements.id == "mianfei_zhuanyuan") {
                        this.roleType = '4';
                    }

                });
            },
			/*此方法用于解决最后审核日期为CST格式转换为GMT格式跨时区问题 hyl*/
			formatDateGMT(row, column) {
				// 获取单元格数据
				let data = row[column.property]
				if(data == null || data == '') {
					return null
				}

				var dateStr=data.trim().split(" ");
				var strGMT = dateStr[0]+" "+dateStr[1]+" "+dateStr[2]+" "+dateStr[5]+" "+dateStr[3]+" GMT+0800";
				let dt = new Date(Date.parse(strGMT));
				return this.$util.riQi3(dt);
			},
        },
        created() {
            // this.showzhezhao()
            this.getRole();
            this.query();
        },
        beforeCreate() {

        },
        mounted() {
        },
    }
</script>
<style scoped>
    .xiangmu > .h-piece, .h-mrt30 {
        margin: 20px;
    }
</style>
<style scoped lang="scss">
    .bottomTip {
        position: absolute;
        left: 49.7%;
        bottom: 0.3rem;
        transform: translateX(-50%);
    }

    .newtext {
        font-size: 0.28rem;
        color: white;
        position: absolute;
        top: 0.2rem;
        left: 50%;
        transform: translateX(-50%);
        font-weight: bold;
        text-shadow: 1px 1px 4px #2785E7;
        z-index: 2;
    }

    .leaderBox {
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.4);
        position: fixed;
        z-index: 99999;
        overflow: hidden;
        top: 0;
        left: 0;

        .leaderbg {
            width: 100%;
            height: 100%;
        }

        .steps {
            position: absolute;
            z-index: 1;
        }

        .step1 {
            top: 0.8rem;
            left: 0rem;
            width: 4.9rem;
            height: 8rem;
        }

        .step2 {
            top: 1.65rem;
            left: 2.8rem;
            width: 10.2rem;
            height: 1.85rem;
        }

        .step3 {
            top: 3.65rem;
            right: 0.8rem;
            width: 5rem;
            height: 1rem;
        }

        .stepbtn {
            width: 1.9rem;
            height: 0.6rem;
            border: 0.03rem solid #FFFFFF;
            background-color: rgba(0, 0, 0, 0.1);
            border-radius: 5px;
            display: flex;
            justify-content: center;
            line-height: 0.5rem;
            position: absolute;
            z-index: 99;
            bottom: 0.65rem;
            left: 50%;
            transform: translateX(-50%);
            font-size: 0.27rem;
            letter-spacing: 2px;
            color: white;
            cursor: pointer;
        }

        .closeIt {
            width: 0.3rem;
            height: 0.3rem;
            position: absolute;
            top: 0.2rem;
            right: 0.2rem;
            cursor: pointer;
        }
    }
</style>
